import { Controller } from "stimulus"
import { Modal, initFlowbite } from "flowbite";

export default class extends Controller {
  static targets = ["generate", "type", "info"]

  connect() {
    // Initialize all Flowbite components
    initFlowbite();

    // Initialize specific modal instances
    this.modalInstances = {
      brand: new Modal(document.getElementById('describe-brand-modal')),
      persona: new Modal(document.getElementById('describe-persona-modal')),
      image: new Modal(document.getElementById('describe-image-modal')),
      product: new Modal(document.getElementById('describe-product-modal')),
      service: new Modal(document.getElementById('describe-service-modal')),
      target_group: new Modal(document.getElementById('describe-target-group-modal'))
    };

    // Set up event listeners
    $(this.typeTarget).on('change', this.toggleInfo.bind(this));
    this.toggleInfo();

    // Initialize hide functionality for modal close buttons
    this.initializeModalHideButtons();
  }

  disconnect() {
    // Clean up event listeners when controller is disconnected
    $(this.typeTarget).off('change');
  }

  initializeModalHideButtons() {
    document.querySelectorAll('[data-modal-hide]').forEach(button => {
      button.addEventListener('click', (e) => {
        const modalId = button.getAttribute('data-modal-hide');
        const modalElement = document.getElementById(modalId);
        if (modalElement) {
          const modalInstance = new Modal(modalElement);
          modalInstance.hide();
        }
      });
    });
  }

  toggleInfo() {
    if (this.typeTarget.value === "image") {
      this.infoTarget.classList.remove("hidden");
    } else {
      this.infoTarget.classList.add("hidden");
    }
  }

  openModal() {
    const type = this.typeTargets[0].value;
    const modalInstance = this.modalInstances[type];
    if (modalInstance) {
      modalInstance.show();
    }
  }
}